import axios from 'axios'

const API = process.env.REACT_APP_API_BASE_URL

/**
 * laender — die ISO-3166-1-alpha-2-Menge der Prüfschicht, vom Backend.
 *
 * 🔴 Keine Kopie der Liste im Frontend. `backend/lieferant_pruefung.py::LAENDER`
 * hat 249 Codes; ein Spiegel (Muster `utils/incoterm.js` für drei Incoterms)
 * wäre hier eine zweite Liste, die ein Wächter nur hütet. `GET /api/vendors/laender`
 * liefert die Codes, den Namen zum Code kennt der Browser (`Intl.DisplayNames`).
 * Die zweite, kleinere Liste `SHIP_FROM_COUNTRIES` (18 Codes der Ship-from-
 * Karte in `VendorDetails.jsx`) ist mit Stufe b des Versandort-Plans
 * (2026-09-26) samt Karte entfallen; diese Menge ist die einzige.
 *
 * Namen auf ENGLISCH (Owner-Entscheid 2026-08-02: Tool-UI ist durchgängig
 * englisch, wie der Overview-Reiter, in dem der Abschnitt hängt).
 *
 * Modul-Cache: die Menge ist eine Konstante des Backends. Der Dialog wird je
 * Öffnen neu gemountet; ohne Cache wäre jedes Öffnen ein GET (Regel-15-Tor
 * 2026-09-25, Warnung 4). Ein Fehlschlag wird nicht gecacht, der nächste
 * Versuch fragt wieder.
 */
let cache = null

export async function ladeLaender() {
  if (cache) return cache
  const { data } = await axios.get(`${API}/api/vendors/laender`)
  const codes = Array.isArray(data?.laender) ? data.laender : []
  if (codes.length) cache = codes
  return codes
}

/** Für Proben: den Modul-Cache leeren. */
export function laenderCacheLeeren() {
  cache = null
}

let anzeigeNamen = null

/** Englischer Ländername zum Code, oder null, wenn der Browser keinen kennt. */
export function landName(code) {
  if (!code) return null
  try {
    if (!anzeigeNamen) anzeigeNamen = new Intl.DisplayNames(['en'], { type: 'region' })
    const name = anzeigeNamen.of(code)
    return name && name !== code ? name : null
  } catch {
    return null
  }
}

/** „Germany (DE)", oder nur „DE", wenn kein Name bekannt ist. */
export function landEtikett(code) {
  const name = landName(code)
  return name ? `${name} (${code})` : code
}

/** Die Codes als `{ code, etikett }`, nach englischem Namen sortiert. */
export function laenderSortiert(codes) {
  return (codes || [])
    .map((code) => ({ code, etikett: landEtikett(code) }))
    .sort((a, b) => a.etikett.localeCompare(b.etikett, 'en'))
}
